var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "modal-h1 mb-3" }, [
      _c("button", {
        staticClass: "btn btn-back",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.$emit("cancel")
          }
        }
      }),
      _vm._v("\n    Create Carrier\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "l-bg-white" }, [
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Carrier name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.carrier.name,
                        expression: "carrier.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Name" },
                    domProps: { value: _vm.carrier.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.carrier, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "name" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v("\n            Cancel\n          ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary ld-ext-right",
                  class: _vm.loadingButton ? "running" : "",
                  attrs: { disabled: _vm.buttonDisabled || !_vm.formInvalid }
                },
                [
                  _vm._v("\n            Create\n            "),
                  _c("div", { staticClass: "ld ld-ball ld-flip" })
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e61aa2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e61aa2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarriersCreate.vue
// module id = null
// module chunks = 